<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links"/>
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link tag="a" :to="{name: 'RegisterHumor'}" class="content--card-register" style="min-height: 200px">
              <img class="img-fluid" src="@/assets/img/image-plus.png" alt="image plus" title="image plus"/>
            </router-link>
          </div>
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3" v-for="humor in moods.data" :key="humor.id">
            <CardHumor :humor="humor"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardHumor from '@/views/Humor/components/CardHumor';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
      {
          name: 'Humor',
          routerName: 'Humor'
        },
        {
          name: 'Listar Humores',
          routerName: 'ListMoods'
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      moods: 'Humor/moods'
    })
  },
  components: {
    Breadcrumb,
    CardHumor
  },
  methods: {
    ...mapActions('Humor', ['consultMoods'])
  },
  mounted() {
    this.consultMoods();
  }
}
</script>

<style lang="scss">
</style>
